import { NovaObraData, ReportDefaults } from "@/hooks/useNovaObra";
import * as obraCache from "@/lib/obraCache";

export interface Obra extends Omit<NovaObraData, 'dataInicio' | 'previsaoTermino'> {
  id: string;
  dataInicio?: string;
  previsaoTermino?: string;
  createdAt: string;
  updatedAt: string;
}

const DEFAULT_REPORT_DEFAULTS: ReportDefaults = {
  condicoesClimaticas: true,
  maoDeObra: true,
  equipamentos: true,
  atividades: true,
  ocorrencias: true,
  materiais: true,
  comentarios: true,
  fotos: true,
  videos: true,
  anexos: true,
};

// Delegação para o store em memória hidratado do Supabase (src/lib/obraCache).
// A API permanece síncrona (usada em tempo de render por várias telas); os
// dados vêm do Supabase (hidratados no login) e as escritas são write-through.

export const getObras = (): Obra[] =>
  obraCache.listObras() as unknown as Obra[];

export const getObraById = (id: string): Obra | null =>
  (obraCache.getObraById(id) as unknown as Obra) ?? null;

export const saveObra = (obraData: NovaObraData): Obra =>
  obraCache.saveObra(obraData) as unknown as Obra;

export const updateObra = (id: string, updates: Partial<Obra>): Obra | null =>
  (obraCache.updateObra(id, updates as any) as unknown as Obra) ?? null;

export const deleteObra = (id: string): boolean => {
  obraCache.deleteObra(id);
  return true;
};

export const getObraReportDefaults = (obraId: string): ReportDefaults | null => {
  const obra = obraCache.getObraById(obraId);
  return obra?.reportDefaults ?? DEFAULT_REPORT_DEFAULTS;
};

export const updateObraReportDefaults = (obraId: string, reportDefaults: ReportDefaults): boolean => {
  const result = obraCache.updateObra(obraId, { reportDefaults });
  return result !== undefined;
};
